import { atom } from "recoil";
import { LinkedWindowEventType } from "../Types/LinkedWindowInfo";

export type TimelinePlayPauseAction = "play" | "pause"

export type TimelinePlayPauseCommand = {
    id: number
    action: TimelinePlayPauseAction
    targetWindowId: string | null
    requestId?: number
}

export type TimelinePlayThroughPayload = {
    annotationStart: number
    annotationEnd: number
}

export type TimelinePlayThroughCommand = {
    id: number
    action: "playThrough"
    targetWindowId: string | null
    requestId?: number
    payload: TimelinePlayThroughPayload
}

export type TimelinePlaybackCommand = TimelinePlayPauseCommand | TimelinePlayThroughCommand

export type TimelineViewRange = {
    start: number
    end: number
}

export type LinkedWindowsTimelineControllerMode = "manual" | "annotationPlaythrough"

export type LinkedWindowsTimelineControllerState = {
    windowId: string
    mode: LinkedWindowsTimelineControllerMode
    requestId?: number
}

export type LinkedWindowsTimelineController = string | LinkedWindowsTimelineControllerState | null

export type LinkedWindowJumpType = LinkedWindowEventType.JUMP_END | LinkedWindowEventType.JUMP_MIDDLE

export const getTimelineControllerWindowId = (controller: LinkedWindowsTimelineController): string | null => {
    if (controller === null || controller === undefined || controller === "") {
        return null
    }

    if (typeof controller === "string") {
        return controller
    }

    return controller.windowId
}

export const isAnnotationPlaythroughController = (controller: LinkedWindowsTimelineController): controller is LinkedWindowsTimelineControllerState => {
    return controller !== null && typeof controller !== "string" && controller.mode === "annotationPlaythrough"
}

// The window Id that is currently controlling the play/pause on the timeline
// null if no window's timeline is currently playing.
export const linkedWindowsTimelineControllerAtom = atom<LinkedWindowsTimelineController>({
    key: "linkedWindowsTimelineController",
    default: null
})

export const linkedWindowJumpTypeAtom = atom<LinkedWindowJumpType>({
    key: "linkedWindowJumpType",
    default: LinkedWindowEventType.JUMP_END,
})

// Global play/pause command bus. Consumers should treat each new object (id) as a
// single-use command.
export const timelinePlaybackCommandAtom = atom<TimelinePlaybackCommand | null>({
    key: "timelinePlaybackCommand",
    default: null
})

// Latest view window ranges (in ms since epoch) for each visualization window.
export const timelineViewRangesAtom = atom<Record<string, TimelineViewRange>>({
    key: "timelineViewRanges",
    default: {}
})
